// get MANUFACTURER
export const GET_MANUFACTURAL_LIST = "GET_MANUFACTURAL_LIST";
export const GET_MANUFACTURAL_LIST_SUCCESS ="GET_MANUFACTURAL_LIST_SUCCESS";
export const GET_MANUFACTURAL_LIST_FAIL = "GET_MANUFACTURAL_LIST_FAIL";
// Add MANUFACTURER
export const ADD_NEW_MANUFACTURAL = "ADD_NEW_MANUFACTURAL";
export const ADD_NEW_MANUFACTURAL_SUCCESS = "ADD_NEW_MANUFACTURAL_SUCCESS";
export const ADD_NEW_MANUFACTURAL_FAIL = "ADD_NEW_MANUFACTURAL_FAIL";
//Update MANUFACTURER
export const UPDATE_MANUFACTURAL = "UPDATE_MANUFACTURAL";
export const UPDATE_MANUFACTURAL_SUCCESS = "UPDATE_MANUFACTURAL_SUCCESS";
export const UPDATE_MANUFACTURAL_FAIL = "UPDATE_MANUFACTURAL_FAIL";
//delete MANUFACTURER
export const DELETE_MANUFACTURER = "DELETE_MANUFACTURER";
export const DELETE_MANUFACTURER_SUCCESS = "DELETE_MANUFACTURER_SUCCESS";
export const DELETE_MANUFACTURER_FAIL = "DELETE_MANUFACTURER_FAIL";
